import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import moment from "moment/moment";


export default function useValidateMaturityDate(state) {
    const beneficiary = state.beneficiary;
    const plan = state.plan;
    const setPlan = state.setPlan;

    //When the maturity date is changed, we only allow it to be on the same day of the month as the effective date.
    //But also it could be when the bene is 17 instead of 18 due to Alberta rules
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!plan.maturityDate) { return; }

        try {
            const beneBirthYear = moment(beneficiary.birthdate).year();
            let maturityDate = moment(plan.maturityDate);
            maturityDate.month(moment(plan.effectiveDate).month());
            maturityDate.date(moment(plan.effectiveDate).date());

            //The maturity date can be in year 17 in some cases, so we allow it or 18 but nothing else
            //If it's something other than 17 or 18, set it to 18.
            if (!(moment(maturityDate).year() === beneBirthYear + 17 || moment(maturityDate).year() === beneBirthYear + 18)) {
                maturityDate.year(beneBirthYear + 18);
            }

            // Only call setPlan if the new maturityDate is different from the current one to prevent loops
            const newMaturityDate = moment(maturityDate).toDate().toISOString().substring(0, 10);
            if (newMaturityDate !== plan.maturityDate) {
                setPlan(prevData => ({...prevData, maturityDate: newMaturityDate}));
            }
        } catch (e) {
            console.error(e);
        }
        debugLog("useValidateMaturityDate");
    }, [plan.maturityDate]);



    const plan2 = state.plan;
    const setPlan2 = state.setPlan;
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!plan2.maturityDate) { return; }

        try {
            const beneBirthYear = moment(beneficiary.birthdate).year();
            let maturityDate = moment(plan.maturityDate);
            maturityDate.month(moment(plan.effectiveDate).month());
            maturityDate.date(moment(plan.effectiveDate).date());

            //The maturity date can be in year 17 in some cases, so we allow it or 18 but nothing else
            //If it's something other than 17 or 18, set it to 18.
            if (!(moment(maturityDate).year() === beneBirthYear + 17 || moment(maturityDate).year() === beneBirthYear + 18)) {
                maturityDate.year(beneBirthYear + 18);
            }

            // Only call setPlan if the new maturityDate is different from the current one to prevent loops
            const newMaturityDate = moment(maturityDate).toDate().toISOString().substring(0, 10);
            if (newMaturityDate !== plan.maturityDate) {
                setPlan2(prevData => ({...prevData, maturityDate: newMaturityDate}));
            }
        } catch (e) {
            console.error(e);
        }
        debugLog("useValidateMaturityDate");
    }, [plan2.maturityDate]);
}